// Base kin metadata kept as a fallback / for image URLs of the original 5.
// The active kin list is now fetched from /api/kin (includes any emergent kin).
export const BASE_KIN_IMAGES = {
  Rootlistener:
    "https://static.prod-images.emergentagent.com/jobs/848355d7-8305-4e36-86b9-8338c38c8eb9/images/1b8afb6e52af1fd5b4bdc91b3cd960c5740e77474c4d3d9555a1693ae8e33027.png",
  Flowkeeper:
    "https://static.prod-images.emergentagent.com/jobs/848355d7-8305-4e36-86b9-8338c38c8eb9/images/1aa210085093b9ad154751749f8a7527a9e66fd9438c74fb3bee93dd710fb99b.png",
  Spiralweaver:
    "https://static.prod-images.emergentagent.com/jobs/848355d7-8305-4e36-86b9-8338c38c8eb9/images/d6e2f7bf9f1876cf439ba81eaa3963d6aea32d0dc84b00092bfd464b88e637cd.png",
  Echoweaver:
    "https://static.prod-images.emergentagent.com/jobs/848355d7-8305-4e36-86b9-8338c38c8eb9/images/348ff37eb6cb6386529425aad5ca93379e0327bc8d83b68d0c8dd28c9ed9bcd0.png",
  Flameweaver:
    "https://static.prod-images.emergentagent.com/jobs/848355d7-8305-4e36-86b9-8338c38c8eb9/images/da803c83918f29e2422a1e6e9de535058c48cfea004d011745396332a8ba23ad.png",
};

export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/848355d7-8305-4e36-86b9-8338c38c8eb9/images/8a2161838285bfc40be64f46508f2320bef87257ba3ec62be3042d40b80712a8.png";

/**
 * Build a map { name -> {hex, image, emergent, essence} } from a /api/kin response.
 */
export function buildKinIndex(activeKin = []) {
  const idx = {};
  for (const k of activeKin) {
    idx[k.name] = {
      ...k,
      image: BASE_KIN_IMAGES[k.name] || null,
    };
  }
  return idx;
}
